
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How do I prepare for my consultation?",
    answer: "After booking, you'll receive a preparation guide with suggested documents to gather and questions to consider. For Fair Deal consultations, have your financial documents ready. For care assessments, think about specific care needs and preferences."
  },
  {
    question: "What happens if I need to reschedule?",
    answer: "You can reschedule or cancel through the Google Calendar booking system. Cancellations made 24+ hours in advance receive full refunds, while same-day cancellations may be subject to fees as outlined in the booking terms."
  },
  {
    question: "Do you offer follow-up support?",
    answer: "Yes! Each consultation includes follow-up resources and a summary of your action plan. Additional consultations can be booked if needed, and we offer package deals for ongoing support."
  },
  {
    question: "Are consultations confidential?",
    answer: "Absolutely. All consultations are completely confidential. We adhere to strict privacy policies and will never share your personal information without your explicit consent."
  },
  {
    question: "What technology do I need for video consultations?",
    answer: "You'll need a device with internet access, camera, and microphone (computer, tablet, or smartphone). We use Google Meet, which works in web browsers - no software installation required."
  },
  {
    question: "Can family members join the consultation?",
    answer: "Yes, family members are welcome to join. When booking, please let us know how many people will be attending so we can ensure the session time accommodates everyone's questions."
  }
];

export function ConsultationFAQ() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Have questions about our consultation services? Find answers to the most 
            common questions below.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
